<template>
  <img v-if="imageSource" v-bind="$attrs" class="system-message-icon" :src="imageSource" :style="iconStyle" alt="" />
  <component
    :is="iconComponent"
    v-else
    v-bind="$attrs"
    class="system-message-icon"
    :style="iconStyle"
    aria-hidden="true"
    focusable="false"
  />
</template>

<script setup>
import { computed } from 'vue'
import { BASE_URL } from 'src/common/config'
import { SYSTEM_MESSAGE_ICONS } from './system-message-icons.js'

const props = defineProps({
  icon: {
    type: String,
    default: 'info',
  },
  src: {
    type: String,
    default: null,
  },
  size: {
    type: Number,
    default: 48,
  },
})

defineOptions({ inheritAttrs: false })

const iconName = computed(() => props.icon || 'info')

const imageSource = computed(() => {
  if (props.src) {
    return props.src
  }

  return iconName.value.startsWith('/') ? BASE_URL + iconName.value : null
})

const iconComponent = computed(() => SYSTEM_MESSAGE_ICONS[iconName.value] ?? SYSTEM_MESSAGE_ICONS.info)

const iconStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}))
</script>

<style scoped>
.system-message-icon {
  display: block;
  flex: 0 0 auto;
  object-fit: contain;
  color: var(--color-icon-primary);
}
</style>
